import { useMonthPicker } from '../../../../../components/month-picker/useMonthPicker';
import { StatsFilters } from '../../../../../domain/statsFilters';

type SingleMonthPickerProps = {
    singleMonthYear: StatsFilters['singleMonthYear'];
    onChange: (newSingleMonthYear: NonNullable<StatsFilters['singleMonthYear']>) => void;
}

export const SingleMonthPicker = ({ singleMonthYear, onChange }: SingleMonthPickerProps) => {
    const handleMonthYearChange = (month: number, year: number) => {
        onChange({
            month: month,
            year: year,
        });
    }

    const { MonthPicker } = useMonthPicker({
        month: singleMonthYear?.month,
        year: singleMonthYear?.year,
        onMonthYearChange: handleMonthYearChange
    });

    return <MonthPicker />;
}